<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">业务基础信息管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>区域基本管理</div>
        </div>
      </div>
    </div>
    <div class="top">
      <div class="street">
        <span>{{ streetInfo.pointName }}</span>
        <el-button
          @click="openDialog(streetInfo)"
          icon="el-icon-edit"
          type="text"
          >编辑</el-button
        >
      </div>
      <div class="content">{{ streetInfo.briefInfo }}</div>
      <div class="info-box">
        <div class="info-box-item">
          <img src="@/assets/image/ld.png" alt="" />
          <span style=" color: #92979C;">楼栋数</span>
          <span>{{ streetInfo.buildingInfo }}</span>
        </div>
        <div class="info-box-item">
          <img src="@/assets/image/mj.png" alt="" />
          <span style=" color: #92979C;">面积</span>
          <span>{{ streetInfo.areaInfo }}</span>
        </div>
      </div>
      <div class="info-box">
        <div class="info-box-item">
          <img src="@/assets/image/dh.png" alt="" />
          <span style=" color: #92979C;">咨询、监督电话</span>
          <span>{{ streetInfo.phoneList }}</span>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="left">
        <div class="title">社区管理</div>
        <div class="search-box">
          <el-input
            style="margin-right: 24px;"
            placeholder="请输入点位名称"
            prefix-icon="el-icon-search"
            v-model="community"
          >
          </el-input>
        </div>
        <div class="type-list">
          <div
            class="type-list-item"
            :class="{ active: curId == item.id }"
            v-for="(item, index) in communityList"
            :key="index"
            @click="communityChange(item)"
          >
            <div class="item-bottom">
              <div class="status">
                <img
                  style="height: 30px;margin-right: 8px;"
                  src="@/assets/image/ll.png"
                  alt=""
                />
                <span>{{ item.pointName }}</span>
              </div>
              <div
                class="edit"
                @click="openDialog(item)"
                v-if="curId == item.id"
              >
                <el-button icon="el-icon-edit" type="text">编辑</el-button>
              </div>
            </div>
            <div class="info-box info-box2">
              <div class="info-box-item">
                <img src="@/assets/image/rs.png" alt="" />
                <span style=" color: #92979C;">网格长</span>
                <span>{{ item.streetChiefName }}</span>
              </div>
            </div>
            <div class="info-box info-box2">
              <div class="info-box-item">
                <img src="@/assets/image/dh.png" alt="" />
                <span style=" color: #92979C;">咨询、监督电话</span>
                <span>{{ item.phoneList }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">{{ levelName2 }}网格管理</div>
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%;width: 100%;">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
              >
                <el-form-item label="">
                  <el-input
                    v-model="block"
                    clearable
                    placeholder="请输入点位名称"
                  ></el-input>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="openWgDialog()" class="search"
                    >新增网格</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside street-list">
          <div
            class="street-item"
            @click="blockChange(item)"
            :class="{ active: curBlockId == item.id }"
            v-for="(item, index) in blockList"
          >
            <div class="street-item-top">
              <div class="top-left-img">
                <img src="@/assets/image/tp.png" alt="" />
              </div>
              <div class="right-info">
                <div class="name">
                  <span>{{ item.pointName }}</span>
                  <el-dropdown @command="handleCommand($event, item)">
                    <span class="el-dropdown-link">
                      <i class="el-icon-more"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="a" icon="el-icon-edit"
                        >编辑</el-dropdown-item
                      >
                      <el-dropdown-item command="b" icon="el-icon-delete-solid"
                        >删除</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <div @click="openWgDialog(item)" v-if="curBlockId == item.id">
                    <el-button icon="el-icon-edit" type="text">编辑</el-button>
                  </div> -->
                </div>
                <div class="info-content">{{ item.blockScope }}</div>
              </div>
            </div>
            <div class="info-box info-box2">
              <div class="info-box-item">
                <img src="@/assets/image/rs.png" alt="" />
                <span style=" color: #92979C;">网格长</span>
                <span>{{ item.streetChiefName }}</span>
              </div>
            </div>
            <!-- <div class="info-box info-box2">
              <div class="info-box-item">
                <img src="@/assets/image/rs.png" alt="" />
                <span style=" color: #92979C;">街区人口</span>
                <span>{{ item.population }}</span>
              </div>
            </div> -->
            <div class="info-box info-box2">
              <div class="info-box-item">
                <img src="@/assets/image/dh.png" alt="" />
                <span style=" color: #92979C;">咨询、监督电话</span>
                <span>{{ item.phoneList }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <streetDialog
      v-if="dialogVisible"
      @refreshList="refreshList"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </streetDialog>
    <wgDialog
      v-if="wgDialogVisible"
      @refreshList="refreshList"
      :dialogVisible.sync="wgDialogVisible"
      :curItem="curItem"
    >
    </wgDialog>
  </div>
</template>
<script>
import { getPointLevelThreeListById } from "@/api/base.js";
import { relDelPointAndDept } from "@/api/point.js";
import commonTable from "@/components/table/index.vue";
import streetDialog from "./components/streetDialog.vue";
import wgDialog from "./components/wgDialog.vue";
export default {
  components: {
    commonTable,
    streetDialog,
    wgDialog
  },
  data() {
    return {
      community: "",
      block: "",
      dialogVisible: false,
      page: {
        size: 9,
        page: 1,
        total: 0
      },
      communityList: [],
      communityAllList: [],
      curId: 0,
      curBlockId: 0,
      blockList: [],
      blockAllList: [],
      wgDialogVisible: false,
      levelName2: "",
      curItem: {},
      streetInfo: {}
    };
  },
  mounted() {
    this.getPointLevelThreeListByIdFun(0, "street");
  },
  methods: {
    refreshList(type) {
      if (type == 1) {
        this.getPointLevelThreeListByIdFun(0, "street");
      } else if (type == 2) {
        this.getPointLevelThreeListByIdFun(this.streetInfo.id, "community");
      } else if (type == 3) {
        this.getPointLevelThreeListByIdFun(this.curId, "block");
      }
    },
    streetHandle(data) {
      if (data && data.length) {
        this.streetInfo = data[0];
        if (this.streetInfo.consultationHotline)
          this.streetInfo.phoneList = JSON.parse(
            this.streetInfo.consultationHotline
          )
            .map(item => item.phone)
            .join("、");
        this.getPointLevelThreeListByIdFun(this.streetInfo.id, "community");
      }
    },
    communityHandle(data) {
      this.communityAllList = data || [];
      if (this.communityAllList.length) {
        this.curId = this.communityAllList[0].id;
        this.levelName2 = this.communityAllList[0].pointName;
        this.getPointLevelThreeListByIdFun(this.curId, "block");
        this.communityAllList.forEach(item => {
          if (item.consultationHotline)
            item.phoneList = JSON.parse(item.consultationHotline)
              .map(itm => itm.phone)
              .join("、");
        });
      }
      this.communityList = JSON.parse(JSON.stringify(this.communityAllList));
    },
    blockHandle(data) {
      this.blockAllList = data || [];
      this.page.total = this.blockAllList.length;
      if (this.blockAllList.length) {
        this.curBlockId = this.blockAllList[0].id;
        this.blockAllList.forEach(item => {
          if (item.consultationHotline)
            item.phoneList = JSON.parse(item.consultationHotline)
              .map(itm => itm.phone)
              .join("、");
        });
      }
      this.blockList = JSON.parse(JSON.stringify(this.blockAllList));
    },
    blockChange(item) {
      this.curBlockId = item.id;
    },
    communityChange(item) {
      this.curId = item.id;
      this.levelName2 = item.levelName2;
      this.getPointLevelThreeListByIdFun(this.curId, "block");
    },
    openDialog(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    openWgDialog(item) {
      console.log(item, "item");

      this.wgDialogVisible = true;
      if (item) {
        this.curItem = item;
      } else {
        this.curItem = {
          levelName1: "中关村街道",
          levelName2: this.levelName2,
          isAdd: true,
          pid: this.curId
        };
      }
    },
    handleCommand(command, item) {
      console.log(command, item, "command");
      if (command == "a") {
        this.openWgDialog(item);
      } else {
        this.$confirm("是否确定删除当前网格？", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(async () => {
            this.relDelPointAndDeptFun(item.id);
          })
          .catch(() => {});
      }
    },
    // 网格删除
    async relDelPointAndDeptFun(id) {
      let params = {
        pointId: id
      };
      const res = await relDelPointAndDept(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.refreshList(3);
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 查询字典类型列表
    onSearch() {
      this.blockList = this.blockAllList.filter(
        item => item.pointName.indexOf(this.block) > -1
      );
    },
    // 分页查询
    async getPointLevelThreeListByIdFun(id, type) {
      let params = {
        id: id
      };
      const res = await getPointLevelThreeListById(params);
      if (res.data.code == 200) {
        if (type == "street") {
          this.streetHandle(res.data.data);
        }
        if (type == "community") {
          this.communityHandle(res.data.data);
        }
        if (type == "block") {
          this.blockHandle(res.data.data);
        }
      }
    }
  },
  watch: {
    community: {
      deep: true,
      handler(val) {
        this.communityList = this.communityAllList.filter(
          item => item.pointName.indexOf(val) > -1
        );
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.box-father {
  padding-bottom: 24px;

  .top {
    width: 100%;
    background: #fff url("~@/assets/image/top-base.png") center no-repeat;
    background-size: 100% 100%;
    margin-bottom: 8px;
    padding: 28px 48px;

    .street {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 24px;
      color: #494c4f;
      display: flex;
      justify-content: space-between;
    }

    .content {
      margin-top: 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 18px;
      color: #494c4f;
    }
  }

  .section {
    display: flex;
    padding: 0;
    height: 708px;

    .left {
      width: 25.4%;
      height: 100%;
      overflow: auto;
      padding: 28px 24px;
      padding-right: 0;
      border-right: 1px solid #e0e0e0;
    }

    .right {
      width: 74.6%;
      height: 100%;
      padding: 28px 24px;
      padding-right: 0;
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 12px;
    }
  }
}

.info-box {
  margin-top: 12px;
  display: flex;
  align-items: center;

  .info-box-item {
    display: flex;
    align-items: center;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 16px;
    color: #494c4f;
    margin-right: 54px;

    img,
    span {
      margin-right: 8px;
    }

    img {
      height: 15px;
    }
  }

  .info-box-item:last-child {
    margin-right: 0;
  }
}

.item-bottom {
  height: 30px;
}

.info-box2 {
  margin-top: 8px;

  .info-box-item {
    margin-right: 24px;
    font-size: 14px;
  }
}

.search-box {
  display: flex;
  margin-bottom: 12px;
}

.type-list {
  height: calc(100% - 94px);
  overflow: auto;

  .type-list-item {
    width: 100%;
    // height: 116px;
    padding: 14px 16px;
    // background: #F7FAFF;
    // border-radius: 4px;
    margin-bottom: 8px;
    cursor: pointer;

    .item-top {
      display: flex;
      align-items: center;

      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
        margin-right: 8px;
      }

      .type {
        background: rgba(0, 144, 255, 0.1);
        border-radius: 2px;
        padding: 1px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #0090ff;
      }
    }

    .item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .status {
        display: flex;
        align-items: center;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
      }
    }
  }

  .type-list-item.active {
    border-right: 4px solid #0090ff;
    background: #f7faff;
  }
}

.street-list {
  height: calc(100% - 132px);
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  .street-item {
    width: calc(33% - 10px);
    // height: 158px;
    margin-right: 16px;
    padding: 12px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    cursor: pointer;
    margin-bottom: 16px;

    .street-item-top {
      display: flex;

      .top-left-img {
        width: 77px;
        height: 76px;
        margin-right: 12px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
      }

      .right-info {
        height: 100%;
        width: calc(100% - 90px);
        font-family: MiSans, MiSans;
        font-weight: 700;
        font-size: 18px;
        color: #494c4f;

        .name {
          display: flex;
          justify-content: space-between;
        }

        .info-content {
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 14px;
          color: #494c4f;
          margin-top: 6px;
          display: -webkit-box;
          /* 对于WebKit内核 */
          -webkit-box-orient: vertical;
          /* 垂直方向布局 */
          -webkit-line-clamp: 2;
          /* 限制为两行 */
          overflow: hidden;
          /* 隐藏超出的内容 */
          text-overflow: ellipsis;
          /* 超出文本用省略号显示 */
        }
      }
    }
  }

  .street-item.active {
    background: #f7faff url("~@/assets/image/active.png") center no-repeat;
    background-size: 100% 100%;
    box-shadow: 0px 4px 8px 0px rgba(22, 54, 79, 0.08);

    .name {
      color: #0090ff;
    }
  }

  .street-item:nth-of-type(3n) {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/baseInfo/index.vue